<template>
    <div v-cloak>
        <b-row class="border rounded m-1 p-1 text-right">
            <b-col
                md="6"
                class="m-auto"
                v-if="student.qualification_details.course_type == 'Non-Apprenticeship'"
            >
                The Training Plan meets my learning needs. I have been provided with a timetable and acknowledge that I am expected to also undertake independent personal study. I was notified about changes to the training and assessment and I have received the updated information.
            </b-col>
            <b-col
                md="6"
                class="m-auto"
                v-else-if="student.state == 'VIC'"
            >
                 I have completed a pre-training review and have contributed to development of this plan including the schedule of proposed employer contact points, and competency confirmation process and response time frame. I am aware of my responsibility to ensure that this plan and its ongoing development is implemented and monitored over the duration of the Training Contract.
            </b-col>
            <b-col
                md="6"
                class="m-auto"
                v-else-if="student.state == 'NSW'"
            >
                <p>
                  I, the undersigned, agree that: 
                </p>
                <p>
                  a. I am aware of and agree to my responsibilities as outlined in this Training Plan.
                </p>
                <p>
                  b. I will make every effort to successfully complete the training outlined in this Training Plan.
                </p>
                <p>
                  c. The RTO may provide information to Training Services NSW as specified in (e) and (g) above.
                </p>
                <p>
                  d. Information provided by the RTO in (g) above may be used to initiate competency based completion of the apprenticeship/traineeship.
                </p> 
            </b-col>
            <b-col
                md="6"
                class="m-auto"
                v-else-if="student.state == 'QLD'"
            >
                <strong>Apprentice/Trainee Declaration</strong>
                <p>
                  I agree that the RTO nominated on this Training Plan may provide information concerning any matters relating to my training to my employer and the State Training Authority.
                </p>
                <strong>Apprentice/Trainee, Employer and RTO Declaration</strong>
                <p>
                   We, the undersigned, have participated in the negotiation and development of the training plan. The employer, apprentice/trainee and, if applicable, parent/guardian have jointly selected the RTO. RPL and credit transfer arrangements have been explained to the apprentice/trainee and employer, and, where applicable, offered to the apprentice/trainee.
                </p>
                <p>
                  We understand and support how the training and assessment will happen.
                </p>
                <p>
                  We are also aware of the relevant state training legislation and RTO compliance requirements.
                </p>
                <p>
                  All parties agree that the RTO has provided full details of how to access the RTO training and assessment dispute mechanism.
                </p>
            </b-col>
            <b-col md="4">
                <div v-if="enrolmentDetails && enrolmentDetails['Review_Apprentice_Sign']">
                    <span
                        v-html="enrolmentDetails ? enrolmentDetails['Review_Apprentice_Sign'] : ''"
                    />
                </div>
                <div v-if="!(enrolmentDetails && enrolmentDetails['Review_Apprentice_Sign'])">
                    <b-btn
                        v-b-tooltip.hover
                        title="Student Signature"
                        variant="primary"
                        @click="showModal"
                    >
                        Student
                    </b-btn>
                </div>
            </b-col>
        </b-row>
        <b-modal
            ref="studentSignatureModal"
            v-b-modal.modal-center
            :class="'text-left'"
            size="lg"
            title="Student Signature"
            no-close-on-backdrop
            no-close-on-esc
            ok-title="Save"
            cancel-variant="danger"
            @ok="onSubmit"
            @cancel="hideModal"
        >
            <b-form
                @submit="onSubmit"
            >
                <signature-pad-component
                    v-model="signature"
                    signatureType="Review_Apprentice_Sign"
                />
            </b-form>
        </b-modal>
    </div>
</template>

<script>
/* global _ */
/* global Noty */
/* global axios */
import SignaturePadComponent from '../../SignaturePadComponent.vue';

export default {
    name: 'LevelPartOneBottom',
    components: {
        SignaturePadComponent,
    },
    props: {
        student: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            enrolmentDetails: {},
            signature: '',
        };
    },
    validations: {},
    computed: {
        level() {
            return Number(this.$route.path.split('/')[3].slice(-1));
        },
    },
    watch: {
    },
    created() {
    },
    mounted() {
        this.fetchEnrolmentDetails();
    },
    filters: {
        formatDate(date) {
            if (moment(date).isValid()) {
                return moment(date).format('DD/MM/YYYY');
            }
            return '';
        },
    },
    methods: {
        update() {
            this.debouncedUpdateEnrolmentDetail();
        },
        clearForm() {
            this.signature = '';
        },
        showModal() {
            this.clearForm();
            this.$refs.studentSignatureModal.show();
        },
        onSubmit() {
            if (this.signature !== '') {
                this.isLoading = true;
                axios
                    .patch(`/api/studentSignatureUpdate/${this.student.id}`, {
                        signature: this.signature,
                    })
                    .then((response) => {
                        this.fetchEnrolmentDetails();
                        const n = new Noty({
                            text: 'Siganture Saved',
                            type: 'success',
                            modal: false,
                        });
                        n.show();
                        this.signature = '';
                    })
                    .catch((error) => {
                        new Noty({
                            text: error.response.data.message,
                            type: 'error',
                            timeout: 1000,
                        }).show();
                    });
            }
        },
        hideModal() {
            this.$refs.studentSignatureModal.hide();
        },
        fetchEnrolmentDetails() {
            this.isLoading = true;
            axios
                .get('/api/enrolmentDetail', {
                    params: {
                        banner_id: this.student.banner_id,
                        course_id: this.student.course_id,
                        level: 0,
                    },
                })
                .then((response) => {
                    //  remove blank teachers
                    this.enrolmentDetails = response.data.data[0];
                    this.isLoading = false;
                })
                .catch((error) => {
                    const n = new Noty({
                        text: error.response.data.message,
                        type: 'error',
                    });
                    n.show();
                });
        },
    },
};
</script>
